import API_BASE_URL from '../config';

let publicPagesPromise = null;
let basicPublicPagesPromise = null;

export async function getPublicPages(forceRefresh = false) {
  if (forceRefresh) publicPagesPromise = null;
  if (publicPagesPromise) return publicPagesPromise;
  publicPagesPromise = fetch(`${API_BASE_URL}/pages`)
    .then(res => res.json())
    .catch(err => {
      publicPagesPromise = null;
      throw err;
    });
  return publicPagesPromise;
}

export async function getBasicPublicPages(forceRefresh = false) {
  if (forceRefresh) basicPublicPagesPromise = null;
  if (basicPublicPagesPromise) return basicPublicPagesPromise;
  basicPublicPagesPromise = fetch(`${API_BASE_URL}/pages?basic=true`)
    .then(res => res.json())
    .catch(err => {
      basicPublicPagesPromise = null;
      throw err;
    });
  return basicPublicPagesPromise;
}

export async function getPageBySlug(slug) {
  const res = await fetch(`${API_BASE_URL}/pages/slug/${encodeURIComponent(slug)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error('Failed to fetch page');
  return res.json();
}

export async function getAllPagesAdmin(token) {
  const res = await fetch(`${API_BASE_URL}/pages/admin/all`, {
    headers: { Authorization: token ? `Bearer ${token}` : '' }
  });
  return res.json();
}

export async function addPage(payload, token) {
  const res = await fetch(`${API_BASE_URL}/pages/admin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: token ? `Bearer ${token}` : '' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Server error ${res.status}`);
  }
  return res.json();
}

export async function updatePage(id, payload, token) {
  const res = await fetch(`${API_BASE_URL}/pages/admin/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: token ? `Bearer ${token}` : '' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Server error ${res.status}`);
  }
  return res.json();
}

export async function deletePage(id, token) {
  const res = await fetch(`${API_BASE_URL}/pages/admin/${id}`, {
    method: 'DELETE',
    headers: { Authorization: token ? `Bearer ${token}` : '' }
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Server error ${res.status}`);
  }
  return res.json();
}

export async function uploadPageImage(id, file, token) {
  const fd = new FormData();
  fd.append('image', file);
  const res = await fetch(`${API_BASE_URL}/pages/admin/${id}/upload`, {
    method: 'POST',
    headers: { Authorization: token ? `Bearer ${token}` : '' },
    body: fd
  });
  return res.json();
}

const pageService = { getPublicPages, getPageBySlug, getAllPagesAdmin, addPage, updatePage, deletePage };
export default pageService;
